export default "https://cdn-static.gokick.com/assets/c9d0de51336abe1332e753a6383b3531473fb45b/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";